import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  SimpleChanges
} from '@angular/core';
import {Store} from '@ngxs/store';
import {PersonalCreditReport} from 'app/models/dto/credit-reports/personal-credit-report.model';
import {CreditReportsState} from 'app/store/credit-reports/credit-reports.state';
import {Contact} from 'app/models/dto/contact.model';
import {Observable} from 'rxjs';
import {format, parse} from 'date-fns';

export interface DataListItem {
  label: string;
  value: string | string[];
  cssClass?: string;
  metadata?: {
    extraLabel?: string;
    cssClass?: string;
    pipe?: string;
    link?: string;
    icon?: {
      id: string;
      color: string;
      tooltip: string;
    };
    countryCode?: any;
    phoneCountryCode?: any;
  };
}

@Component({
  selector: 'app-borrower-data-table',
  templateUrl: './borrower-data-table.component.html',
  styleUrls: ['./borrower-data-table.component.scss']
})

export class BorrowerDataTableComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() loading: boolean;
  @Input() dataList: DataListItem[];
  @Input() contacts: Contact[];
  @Output() editClicked = new EventEmitter();
  personalCreditReport$: Observable<PersonalCreditReport>;
  personalCreditReport: PersonalCreditReport;
  minimumMonthlyPayment: number = 0;
  tradelineCount: number = 0;
  moreDetailsOpen: boolean = false;

  specialTableTitles = ['Finances'];

  constructor(
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    if (this.title === 'Finances' || this.title === 'Open Tradelines') {
      this.personalCreditReport$ = this.store.select(CreditReportsState.personalCreditReport);

      this.personalCreditReport$.subscribe((personalCreditReport) => {
        this.personalCreditReport = personalCreditReport;

        if (personalCreditReport && this.title === 'Open Tradelines') {
          const tradelines = personalCreditReport?.tradeLines;
          this.loading = false;

          for (let i = 0; i < tradelines?.length; i++) {
            this.minimumMonthlyPayment += tradelines?.[i]['monthlyPaymentAmount'];
            this.tradelineCount++;
          }
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        const change = changes[propName];

        switch (propName) {
          case 'contacts': {
            if (change.currentValue) {
              if (this.title === 'Business Personnel') {
                this.loading = false;
              }
            }
          }
        }
      }
    }
  }

  enableEditButton() {
    switch (this.title) {
      case 'Finances':
      case 'Borrower Credit':
      case 'Business Personnel':
      case 'Owner Overview':
      case 'Business Overview':
      case 'Business Contact':
        return true;
      default:
        return false;
    }
  }

  onEditClicked() {
    this.editClicked.emit();
  }

  getValueFromDataList(label) {
    if (this.dataList?.length > 0) {
      for (const data of this.dataList) {
        if (data.label === label) {
          return data.value;
        }
        if (data.label === 'Annual Profits' && this.title === 'Finances' && label === 'Monthly Profits') {
          if (typeof data.value === 'string' && data.value) {
            return (Number(data.value.replace(/[^0-9.-]+/g, '')) / 12).toFixed(2);
          } else {
            return data.value;
          }
        }
      }
    }
  }

  getMetaDataFromDataList(label, metadataValue) {
    if (this.dataList?.length > 0) {
      for (const data of this.dataList) {
        if (data.label === label) {
          return data?.metadata?.[metadataValue];
        }
      }
    }
  }

  bankruptcyDateFormat(bankruptcyDate) {
    if (bankruptcyDate) {
      try {
        return format(parse(bankruptcyDate, 'MMddyyyy', new Date()), 'MM/dd/yy');
      } catch (e) {
        return format(new Date(bankruptcyDate), 'MM/dd/yy');
      }
    } else {
      return 'N/A';
    }
  }
}
